$(document).ready(function () {
  let p = $("body").attr("p");
  if (p === "events") {
    const HasposType = localStorage.getItem("postype") ? true : false;
    let posType = "";
    let deviceType = "desktop";

    if (window.matchMedia("(max-width: 767px)").matches) {
      deviceType = "mobile";
    } else if (
      window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches
    ) {
      deviceType = "tablet";
    }
    if (!HasposType) {
      localStorage.setItem("postype", "classic");
    }

    posType = localStorage.getItem("postype");

    // Get the current URL
    var currentUrl = window.location.href;

    // Create a URL object
    var url = new URL(currentUrl);

    // Check if the "pos_type" parameter is already set
    // if (!url.searchParams.has("pos_type")) {
    //   // Modify the query parameters
    //   url.searchParams.set("pos_type", posType);

    //   // Refresh the page with the new URL
    //   window.location.href = url.toString();
    // }
  }

  // if (p === 'organizer_location') {

  $(document).on("change", "#main_location", function () {
    if ($(this).is(":checked")) {
      $("#main-location-confirm-model").modal("show");
    } else {
      $("#is_primary").val("0");
      return;
    }
  });

  $(document).on("click", "#main-location-confirm", function () {
    $("#main_location").prop("checked", true);
    $("#is_primary").val("1");
    $("#main-location-confirm-model").modal("hide");
  });

  $(document).on("click", "#main-location-cancel", function () {
    $("#main_location").prop("checked", false);
    $("#is_primary").val("0");
  });

  //new
  $(document).on("submit", "#organizer-location-reg-form", function (e) {
    e.preventDefault();
    const formData = new FormData($(this)[0]);
    url = "/api/v1/private/organizer-location/new";
    setOrganizerLocation(formData, url);
  });

  //update
  $(document).on("submit", "#organizer-location-update-form", function (e) {
    e.preventDefault();
    const formData = new FormData(this);
    // formData.append("location_id", locationId);
    // formData.append("status", status);
    // if ($(this).attr("data-printer-type") === 'TERMINAL') {
    //   formData.append("type", 'TERMINAL');
    // }
    url = "/api/v1/private/organizer-location/update";
    setOrganizerLocation(formData, url);
  });

  function setOrganizerLocation(formData, url) {
    //save to localStorage
    if (formData.get("main_location") === "on") {
      const mainLocationId = $("#main_location").data("location-id");
      formData.append("mainLocationId", mainLocationId);
    }

    let organizerId = $("body").attr("organizer_id");

    $.ajax({
      type: "POST",
      url,
      data: formData,
      enctype: "multipart/form-data",
      async: true,
      cache: false,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        if (data.message !== undefined && data.message !== null) {
          if (data.location_id && data.organizer_id) {
            localStorage.setItem(
              `${data.organizer_id}_mainLocationId`,
              data.location_id,
            );
          }

          if (data.message) {
            prependAlert("#message", data.message, "success", null);
            $("#organizer-location-reg-form").hide();
            $("#organizer-location-update-form").hide();
            $("#message").show();
            setTimeout(function () {
              document.location.href = `/organizer/${organizerId}/locations`;
            }, 2000);
          }
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }

        if (data.responseJSON) {
          prependAlert(
            "#message-box",
            data.responseJSON,
            "danger",
            null,
            "#organizer-location-reg-form",
          );
        }
      });
  }
  // }
});
